import { Field } from "react-final-form";
import FilesContainer from "component/filesContainer/FilesContainer";
import { PickerAccountDataFilesType } from "pages/pickers/types";
import {
  DETAIL_PICKER_TAG,
  FISCAL_NUMBER_LENGTH,
  VALIDATION_REGEX,
} from "utils/constants";
import { AccountDataProps } from "../types";
import "../../detailPicker.scss";
import "../accountData.scss";
import "../i18n";
import { useTranslation } from "react-i18next";
import { AutoComplete, SelectInput, TextInput } from "@pickit/pickit-components";

const AccountData = ({
  isActivePicker,
  provinces,
  testId,
  fiscalNumberRef,
  setFiscalNumberDuplicated,
  ...props
}: AccountDataProps) => {
  const { t } = useTranslation("account");
  return (
    <div
      data-testId={testId}
      id={testId}
      className="container-detail-picker-fluid card-container"
    >
      <div className="container-detail-picker-row">
        <div
          className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6"
          ref={fiscalNumberRef}
        >
          <Field
            type="text"
            id={testId + "-fiscal-number"}
            testId={testId + "-fiscal-number"}
            name="accountingData.fiscalNumber"
            label={t("fiscalNumber")}
            component={TextInput}
            className="Admin-Pickers-input disabled"
            placeholder={t("fiscalNumberPlaceholder")}
            maxLength={FISCAL_NUMBER_LENGTH.CO}
            pattern={VALIDATION_REGEX.regNumber}
            onChange={() => setFiscalNumberDuplicated(false)}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-account-type"}
            id={testId + "-account-type"}
            name="accountingData.account.type"
            label={t("typeLabel")}
            className="Admin-Pickers-input"
            placeholder={t("typePlaceholder")}
            isValueObject
            options={props.accountTypes?.map((o) => ({
              ...o,
              id: o.tag,
            }))}
          >
            {(props: any) => <SelectInput {...props} />}
          </Field>
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6 ">
          <Field
            type="text"
            testId={testId + "-bank-identifier"}
            id={testId + "-bank-identifier"}
            name="accountingData.account.number"
            label={t("bankIdentifierLabel")}
            component={TextInput}
            pattern={VALIDATION_REGEX.regNumber}
            className="Admin-Pickers-input"
            placeholder={t("bankIdentifierPlaceholder")}
            maxLength={22}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-bank-name"}
            id={testId + "-bank-name"}
            name="accountingData.account.bank"
            label={t("bankNameLabel")}
            className="Admin-Pickers-input"
            placeholder={t("bankNamePlaceholder")}
            isValueObject
            options={props.banks}
            keyProperty="tag"
          >
            {(props: any) => <SelectInput {...props} />}
          </Field>
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-sap-interlocutor"}
            id={testId + "-sap-interlocutor"}
            name="accountingData.sapInterlocutor"
            label={t("sapInterlocutor")}
            component={TextInput}
            showClearIcon={false}
            disabled
            placeholder="-"
            className="Admin-Pickers-input readonly"
          />
        </div>
      </div>
      <div className="container-detail-picker-col-sm-24">
        <div className="divider"></div>
      </div>
      <h3 className="container-detail-picker-row account-data-subtitle">
        {t("fiscalDirection")}
      </h3>
      <div className="container-detail-picker-row">
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-street"}
            id={testId + "-street"}
            name="accountingData.address.street"
            label={t("streetLabel")}
            component={TextInput}
            className="Admin-Pickers-input"
            placeholder={t("streetPlaceholder")}
            maxLength={50}
          />
        </div>
        <div className="container-detail-picker-col-xs-12 container-detail-picker-col-sm-4  container-detail-picker-col-xl-3">
          <Field
            type="text"
            testId={testId + "-street-number"}
            id={testId + "-street-number"}
            name="accountingData.address.streetNumber"
            label={t("streetNumberLabel")}
            component={TextInput}
            className="Admin-Pickers-input"
            placeholder={t("streetNumberPlaceholder")}
            maxLength={10}
          />
        </div>
        <div className="container-detail-picker-col-xs-12 container-detail-picker-col-sm-4  container-detail-picker-col-xl-3">
          <Field
            type="text"
            testId={testId + "-postal-code"}
            id={testId + "-postal-code"}
            name="accountingData.address.postalCode"
            label={t("postalCodeLabel")}
            pattern={VALIDATION_REGEX.regNumber}
            component={TextInput}
            className="Admin-Pickers-input "
            placeholder={t("postalCodePlaceholder")}
            maxLength={7}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-locality"}
            id={testId + "-locality"}
            name="accountingData.address.locality"
            label={t("localityLabel")}
            component={TextInput}
            className="Admin-Pickers-input"
            placeholder={t("localityPlaceholder")}
            maxLength={50}
          />
        </div>
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8  container-detail-picker-col-xl-6">
          <Field
            type="text"
            testId={testId + "-province"}
            id={testId + "-province"}
            name="accountingData.address.province"
            label={t("provinceLabel")}
            className="Admin-Pickers-input"
            placeholder={t("provincePlaceholder")}
            isValueObject
            options={provinces.map((o) => ({
              ...o,
              id: o.tag,
            }))}
            showProperty="name"
            keyProperty="tag"
          >
            {(props: any) => <AutoComplete {...props} />}
          </Field>
        </div>
      </div>
      <FilesContainer<PickerAccountDataFilesType>
        testId={testId + "-files"}
        id={testId + "-files"}
        {...props}
        showDeleteIcon={!isActivePicker}
        names={DETAIL_PICKER_TAG}
      />
    </div>
  );
};

export default AccountData;
